import { createContext, useState } from 'react';
import type { ReactNode } from 'react';

// Create a new context
export const FlowsFormSlideContext = createContext<{ slide: number; setSlide: (arg: number) => void; }>({
  slide: 0,
  setSlide: () => {},
});

// Create a provider component
export const FlowsFormSlideProvider = ({ children }: { children: ReactNode; }) => {
  const [slide, setSlide] = useState(0);

  return (
    <FlowsFormSlideContext.Provider value={{ slide, setSlide }}>
      {children}
    </FlowsFormSlideContext.Provider>
  );
};
